import { api, config } from '../../../../helpers/api';

export async function getTopSendersRequest({ card_id = null, sum_of_values }) {
  const response = await api.get(
    '/leaderboard/sender_by_count',
    config('json', { card_id, sum_of_values })
  );
  return response.data;
}

export async function getTopReceiversRequest({
  card_id = null,
  sum_of_values
}) {
  const response = await api.get(
    '/leaderboard/receiver_by_count',
    config('json', { card_id, sum_of_values })
  );
  return response.data;
}
